import React from 'react'
import PropTypes from 'prop-types'
import {
	Row,
	Col,
  ModalHeader,
  ModalBody,
  Button,
  ModalFooter,
  Modal
} from 'reactstrap'

const AvailableBrandsModal = ({
  isOpen,
  toggle,
  isLoading,
  handleDownloadCSVClick,
  handleDownloadPDFClick,
  handleCloseClick
}) => (
  <Modal isOpen={isOpen} toggle={toggle} backdrop="static" size="sm">
    <ModalHeader className="custom_header_colourTwo" toggle={toggle}>Available Brands</ModalHeader>
    <ModalBody style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
      <Row className="mx-3  ">
        <Col md="12">
          <Button  className="card-just-text btn btn-primaryTwo" disabled={isLoading} onClick={handleDownloadCSVClick}>
            {isLoading ? 'loading' : 'Download excel file'}
          </Button>
        </Col>
       
      </Row>
      <div id='pdf-container'></div>
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={handleCloseClick}>Close</Button>{' '}
    </ModalFooter>
  </Modal>
)

AvailableBrandsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  handleDownloadCSVClick: PropTypes.func.isRequired,
  handleDownloadPDFClick: PropTypes.func.isRequired,
  handleCloseClick: PropTypes.func.isRequired
}

export default AvailableBrandsModal
